import type { ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";

interface AppProviderProps {
  children: ReactNode;
  isHarbour: boolean;
  isBiz4Biz: boolean;
}

export function AppProvider({ children }: AppProviderProps) {
  return <BrowserRouter>{children}</BrowserRouter>;
}
